import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";
import Creator from "@/pcm/store/models/Creator";
import Currency from "@/pcm/store/models/Currency";
import {Statuses} from "@/pcm/types/interfaces/Statuses";
import User from "@/pcm/store/models/User";
import Network from "@/pcm/store/models/Network";

export default class Contract extends Model {
    static entity = 'contracts';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'id',
    };

    static fields() {
        return {
            id: this.uid(),
            creator_id: this.attr(null),
            currency_id: this.attr(null),
            old_contract_id: this.string(null).nullable(),
            network_id: this.attr(null),
            user_id: this.attr(null),
            step: this.number(0),
            status: this.string('concept'),
            type: this.string(null).nullable(),
            template: this.string(null).nullable(),
            purchase_amount: this.number(null).nullable(),
            signed_at: this.string(null).nullable(),
            needs_consigning: this.boolean(false),
            is_checked: this.boolean(false),
            is_paid: this.boolean(false),
            signed_contract: this.string('').nullable(),
            purchase_amount_converted: this.number(null).nullable(),

            contract_url: this.string(null).nullable(),
            signed_contract_url: this.string(null).nullable(),
            signed_contract_import_url: this.string(null).nullable(),
            additional_documents_urls: this.attr([]).nullable(),

            to_configure_count: this.number(null).nullable(),

            created_at: this.string(''),
            updated_at: this.string(''),

            errored_media_imports_count: this.number(null).nullable(),

            creator: this.belongsTo(Creator, 'creator_id'),
            user: this.belongsTo(User, 'user_id'),
            currency: this.belongsTo(Currency, 'currency_id'),
            network: this.belongsTo(Network, 'network_id'),
        }
    }

    declare id: number;
    declare creator_id: number;
    declare user_id: number;
    declare currency_id: number;
    declare old_contract_id: string | null;
    declare network_id: number;
    declare step: number;
    declare status: Statuses;
    declare type: string | null;
    declare template: string | null;
    declare purchase_amount: number | null;
    declare signed_at: string | null;
    declare contract_url: string | null;
    declare signed_contract_url: string | null;
    declare signed_contract_import_url: string | null;
    declare additional_documents_urls: Array<any>;
    declare needs_cosigning: boolean;
    declare is_checked: boolean;
    declare is_paid: boolean;
    declare purchase_amount_converted: number | null;
    declare to_configure_count: number | null;

    declare errored_media_imports_count: number | null;

    declare creator: Creator;
    declare user: User;
    declare currency: Currency;
    declare network: Network;
}
